import React from "react";

const About = () => {
  return (
    <div className="neo card about">
      <div className="about-header">
        Welcome to{" "}
        <span style={{ color: "#2196f3", fontWeight: "bold" }}>UN</span>doubt{" "}
      </div>
      <div className="about-body">
        <p>
          Undoubt is your go-to platform for asking and answering questions,
          where curiosity meets expertise. Whether you're seeking advice,
          solving a problem, or sharing knowledge, Undoubt is designed to
          connect you with a vibrant community of learners and experts.
        </p>
      </div>
    </div>
  );
};

export default About;
